import React from 'react';
import { Modal } from 'react-bootstrap';
import '../styles/resourceManagement.css';

export interface LimsFeedbackModalProps {
  show: boolean;
  onHide: () => void;
  /** 弹窗标题，默认「提示」 */
  title?: string;
  /** 正文，支持 \\n 换行 */
  message: string;
  confirmLabel?: string;
}

/**
 * 与设计规范一致的轻量提示弹窗（替代 window.alert），样式对齐审批流程 / 放置位置模态。
 */
export const LimsFeedbackModal: React.FC<LimsFeedbackModalProps> = ({
  show,
  onHide,
  title = '提示',
  message,
  confirmLabel = '确定'
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdropClassName="lims-storage-modal-backdrop"
      dialogClassName="lims-approval-flow-modal__dialog"
      contentClassName="lims-approval-flow-modal__content"
    >
      <Modal.Header closeButton className="lims-approval-flow-modal__header border-0 pb-0">
        <Modal.Title as="h2" className="lims-approval-flow-modal__title mb-0">
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="lims-approval-flow-modal__body">
        <p className="lims-feedback-modal__text">{message}</p>
      </Modal.Body>
      <Modal.Footer className="lims-approval-flow-modal__footer border-0 d-flex justify-content-end">
        <button type="button" className="lims-approval-flow-modal__btn-primary" onClick={onHide}>
          {confirmLabel}
        </button>
      </Modal.Footer>
    </Modal>
  );
};
